export const decodeHtmlEntities = text => {
  if (!text) {
    return '';
  }
  const parser = new DOMParser();
  const doc = parser.parseFromString(text, 'text/html');
  return doc.documentElement.textContent || '';
};
//# sourceMappingURL=decode-html-entities.js.map